import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LangService } from 'src/app/core/lang.service';
import { WhitelabelService } from 'src/app/domain/whitelabel.service';
import { tzLangAbbrs } from 'src/app/core/util/moment';
import { AuthService } from 'src/app/api/auth.service';
import { RoutesService } from 'src/app/api/routes.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss']
})
export class TopBannerComponent implements OnInit {
  
  showDowntimeBanner:boolean = false;
  use_custom_message:boolean = false;
  custom_message:{ [key: string]: string };
  message_slug:string;
  startDateTime:string; 
  endDateTime:string;
  supportEmail:string;
  supportPhoneNum:string;
  
  constructor(
    private http: HttpClient,
    public lang: LangService,
    private auth: AuthService,
    private routes: RoutesService,
    private whitelabel: WhitelabelService
  ) { }

  ngOnInit(): void {
    this.getBannerInfo()
  }

  /**
   * Get banner info to be displayed
   * banner_on: ON/OFF info - this control the display of the top banner
   * use_custom_message: ON/OFF - this control the display of the custom message or message_slug
   * custom_message in en/fr: custom message to be displayed (optional)
   * message_slug: translation slug to be displayed (optional)
   * start_on: in UTC format YYYY-MM-DDThh:mm:ssZ
   * end_on: in UTC format YYYY-MM-DDThh:mm:ssZ
   * phone: support phone number
   * email: support email
   */ 
  getBannerInfo(){
    const s3link = this.whitelabel.getSiteText('loginTopBannerS3Link')
    this.http.get(s3link)
    .subscribe((data:any) =>{
      if(data.banner_on){
        this.showDowntimeBanner = data.banner_on
        this.use_custom_message = data.use_custom_message
        this.custom_message = data.custom_message
        this.message_slug = data.message_tra_slug
        this.startDateTime = data.start_on
        this.endDateTime = data.end_on
        this.supportEmail = data.email
        this.supportPhoneNum = data.phone
      }
    }, error => {
      console.log(error.message)
      this.showDowntimeBanner = false

      // Log the failed fetch event
      this.auth.apiCreate(this.routes.LOG, {
        slug: 'CLIENT_FETCH_ERROR_TOP_BANNER',
        data: {
          requestURL: s3link,
          error: error.message
        }
      })
    })
  }


  /**
   * Construct banner message and convert UTC datetime to Eastern timezone
   * @return {string} landing page top banner downtime message
   */
  getBannerMsg():string {
    const customMsg = this.custom_message?.[this.lang.c()];
    const isCustomMsgValid =
      this.use_custom_message &&
      typeof customMsg === 'string' &&
      this.isSafeMessage(customMsg);

    if (this.use_custom_message && !isCustomMsgValid) {
      return '';
    }

    const msgSlugOrText = this.use_custom_message ? this.custom_message[this.lang.c()] :
                          this.message_slug ? this.message_slug :
                          'banner_downtime_msg'; // Fallback to banner_downtime_msg if no message_slug is provided

    // Handling date time conversion
    let startDate = '';
    let endDate = '';
    const timezone = this.whitelabel.getTimeZone()
    if(this.startDateTime){
      startDate = moment.tz(this.startDateTime, timezone).format(this.lang.tra('datefmt_login_top_banner'));
      if(this.lang.c() === 'fr'){
        startDate = tzLangAbbrs(startDate, 'fr')
      }
    }
    if(this.endDateTime){
      endDate = moment.tz(this.endDateTime, timezone).format(this.lang.tra('datefmt_login_top_banner'));
      if(this.lang.c() === 'fr'){
        endDate = tzLangAbbrs(endDate, 'fr')
      }
    }

    return this.lang.tra(msgSlugOrText, "", {
      startDateTime: startDate, 
      endDateTime: endDate, 
      supportEmail: this.isSafeMessage(this.supportEmail) ? this.supportEmail : '',
      supportPhone: this.isSafeMessage(this.supportPhoneNum) ? this.supportPhoneNum : ''
    });
  }

  /**
   * Validate custom message - ensure it doesn't contain any HTML tags
   * @param message to be validated
   * @returns {boolean} whether the message is safe to display
   */
  private isSafeMessage(message: string): boolean {
    // Check for any HTML tags using regex
    // /</?[a-z][\s\S]*>/i matches: <tag> or </tag>
    return !!message && !/<\/?[a-z][\s\S]*>/i.test(message);
  }
}
